import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import InvestorPageHeader from "../components/investor/InvestorPageHeader";
import InvestorSectionHeading from "../components/investor/InvestorSectionHeading";
import WalletActivityTransactionRow from "../components/wallet/WalletActivityTransactionRow";
import {
  downloadMyTransactionsCsv,
  downloadMyTransactionsPdf,
  fetchMyTransactions,
} from "../services/paymentService";

const DEFAULT_FILTERS = {
  type: "",
  direction: "",
  date_from: "",
  date_to: "",
  search: "",
  ordering: "-created_at",
};

export default function TransactionsHistoryPage() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const load = async () => {
    setLoading(true);
    setMessage("");
    try {
      const { data } = await fetchMyTransactions(filters);
      setRows(Array.isArray(data) ? data : data?.results || []);
    } catch (err) {
      setMessage(err?.response?.data?.detail || "Failed to load transactions.");
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="page investor-premium investor-panel wallet-page">
      <p className="wallet-breadcrumb">
        <Link to="/wallet">← Wallet & overview</Link>
      </p>
      <InvestorPageHeader
        icon="wallet-activity"
        title="Wallet Activity"
        subtitle="Full history of deposits, share purchases, withdrawals, refunds, and adjustments on your BDT wallet."
      />
      <section className="wallet-section" aria-labelledby="wallet-activity-filters-heading">
        <InvestorSectionHeading icon="filter" tag="h2" id="wallet-activity-filters-heading" className="wallet-section__title" style={{ margin: 0 }}>
          Search & filters
        </InvestorSectionHeading>
        <div className="wallet-activity-filters">
          <div className="wallet-activity-filters__row">
            <label>
              Type
              <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })}>
                <option value="">All types</option>
                <option value="DEPOSIT">Deposit</option>
                <option value="WITHDRAWAL">Withdrawal</option>
                <option value="INVESTMENT">Share purchased</option>
                <option value="REFUND">Redeem Shares</option>
                <option value="ADJUSTMENT">Adjustment</option>
                <option value="TRANSFER">Transfer</option>
              </select>
            </label>
            <label>
              Direction
              <select
                value={filters.direction}
                onChange={(e) => setFilters({ ...filters, direction: e.target.value })}
              >
                <option value="">All directions</option>
                <option value="CREDIT">Credit (money in)</option>
                <option value="DEBIT">Debit (money out)</option>
              </select>
            </label>
            <label>
              Sort
              <select value={filters.ordering} onChange={(e) => setFilters({ ...filters, ordering: e.target.value })}>
                <option value="-created_at">Newest first</option>
                <option value="created_at">Oldest first</option>
                <option value="-amount">Amount high to low</option>
                <option value="amount">Amount low to high</option>
              </select>
            </label>
          </div>
          <div className="wallet-activity-filters__row">
            <label>
              From date
              <input
                type="date"
                value={filters.date_from}
                onChange={(e) => setFilters({ ...filters, date_from: e.target.value })}
              />
            </label>
            <label>
              To date
              <input
                type="date"
                value={filters.date_to}
                onChange={(e) => setFilters({ ...filters, date_to: e.target.value })}
              />
            </label>
            <label>
              Search
              <input
                placeholder="Reference or note"
                value={filters.search}
                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              />
            </label>
          </div>
          <div className="wallet-activity-filters__actions">
            <button type="button" className="wallet-toolbar__primary" onClick={load} disabled={loading}>
              {loading ? "Loading…" : "Apply filters"}
            </button>
            <button type="button" className="btn-secondary" onClick={() => setFilters(DEFAULT_FILTERS)}>
              Reset
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={async () => {
                try {
                  await downloadMyTransactionsCsv(filters);
                } catch (err) {
                  setMessage(err?.response?.data?.detail || "CSV export failed.");
                }
              }}
            >
              Export CSV
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={async () => {
                try {
                  await downloadMyTransactionsPdf(filters);
                } catch (err) {
                  setMessage(err?.response?.data?.detail || "PDF export failed.");
                }
              }}
            >
              Export PDF
            </button>
          </div>
        </div>
      </section>

      {message && <p className="msg msg-error">{message}</p>}

      <section className="wallet-section" aria-labelledby="wallet-activity-results-heading">
        <div className="wallet-activity-results__head">
          <InvestorSectionHeading
            icon="wallet-activity"
            tag="h2"
            id="wallet-activity-results-heading"
            className="wallet-section__title"
            style={{ margin: 0 }}
          >
            Wallet transactions
          </InvestorSectionHeading>
          {!loading && rows.length > 0 ? (
            <p className="wallet-activity-results__count">
              Showing {rows.length} transaction{rows.length === 1 ? "" : "s"}
            </p>
          ) : null}
        </div>
        {loading ? <p className="wallet-empty">Loading transactions…</p> : null}
        {!loading && !rows.length ? (
          <p className="wallet-empty">No transactions match your filters.</p>
        ) : null}
        {!loading && rows.length > 0 ? (
          <ul className="wallet-activity-txn-list">
            {rows.map((t) => (
              <li key={t.id}>
                <WalletActivityTransactionRow row={t} />
              </li>
            ))}
          </ul>
        ) : null}
      </section>
    </div>
  );
}
